/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (_, UpgradeBase, WidgetUpgradeUtils) => {

	class MissingOriginalCustomGroupItemId extends UpgradeBase {

		constructor() {
			super();

			this.VERSION = 1800;
		}

		/**
		 * Perform upgrade to add "originalCustomGroupItemId" to the dataItem when it represents a custom group
		 * @param {object} spec - spec to perform upgrade on
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (!spec) {
				return Promise.resolve(spec);
			}
			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}

			return this._upgradeWidgets(spec);

		}

		down(spec) {
			// Downgrades are not available in CA
			return Promise.resolve(spec);
		}

		_upgradeWidgets(spec) {
			_.each(spec.widgets, model => {
				this._upgradeWidgetProperties(model, spec);
			});
			return Promise.resolve(spec);
		}

		_getContentSpec(model, spec){
			const layout = WidgetUpgradeUtils.findLayout([spec.layout], model.id);
			let content = null;
			if (layout){
				if (!layout.content){
					layout.content = {};
				}
				content = layout.content;
			}
			return content;
		}

		_getContentProps(model, spec) {
			const content = this._getContentSpec(model, spec);
			let props;
			if (content){
				if (!content.properties){
					content.properties = {};
				}
				props = content.properties;
			}
			return props;
		}

		_upgradeVisGridProps(model, props){
			if (model && model.data && model.data.dataViews && model.data.dataViews.length > 0){
				const gridSettings = model.data.dataViews[0].grid;
				if (gridSettings){
					props['datagrid.viewOption'] = gridSettings['viewOption'];
				}
				delete model.data.dataViews[0].grid;
			}
		}


		_upgradeInfoGraphicProps(model, props){
			if (model && model.slotmapping && model.slotmapping.slots && model.slotmapping.slots.length > 0){
				const dataItemSettings = model.slotmapping.slots[0].dataItemSettings;
				if (dataItemSettings && dataItemSettings.length > 0) {
					const graphic = dataItemSettings[0].graphic;
					if (graphic) {
						props['value.graphic.content'] = graphic.content;
						props['value.graphic.currentScaleOption'] = graphic.currentScaleOption;
						props['value.graphic.fillColor'] = graphic.fillColor;
						props['value.graphic.borderColor'] = graphic.borderColor;
					}
				}
				delete model.slotmapping.slots[0].dataItemSettings;
			}
		}

		_upgradeWidgetProperties(model, spec) {
			const props = this._getContentProps(model, spec);
			if (props){
				// Upgrade grid view options to a prop
				this._upgradeVisGridProps(model, props);

				// Upgrade infographic shape props
				this._upgradeInfoGraphicProps(model, props);
			}
		}
	}

	return new MissingOriginalCustomGroupItemId();

});
